/**
 * Pipe Name: 'mask'
 * Inputs and type: number of maskable characters(number), masking character(string) and pre/post mask flag
 *                  (string which is 'pre' by default, pass as 'post' if masking is required for ending characters)
 *
 * Example1: {{ value | mask:4:'#' }} (masks first 4 characters of the input (defaulted to pre when maskFlag is absent) with '#'
 *           as masking character)
 * Example2: {{ value | mask:3:null:'post' }} (masks last 3 characters of the input with '*' (default if no masking character provided)

 * logic update 3/1/2018 -- JC
 * Inputs and type: indicator to enable/disable mask(optional, string), number of characters visible (number, default as 4), masking character(string) and pre/post mask flag
 *                  (string which is 'pre' by default, pass as 'post' if masking is required for ending characters)
 *
 * Example1: {{ value | mask}} or {{ value | mask : 'false'}} (no mask)
 * Example1: {{ value | mask: 'true':4:'#' }} (masks first characters of the input (defaulted to pre when maskFlag is absent) with '#'
 *           as masking character, leaving the last 4 not masked)
 * Example2: {{ value | mask:'true':3:null:'post' }} (masks last characters of the input with '*' (default if no masking character provided), leaving the first 3 not masked.)

**/

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mask' })
export class MaskCharactersPipe implements PipeTransform {
    transform(value: string, maskInd?: string, charCount: number = 4, maskChar?: string, maskFlag?: string): any {
        if (!maskInd || /false/.test(maskInd))
            return value;
        maskChar = maskChar ? maskChar : '*';
        if (charCount && charCount > 0 && value.length > charCount) {
            let regx;
            if (maskFlag && /post/i.test(maskFlag)) {
                regx = new RegExp('^(.{' + charCount + '})(.*)$', 'g');
                value = value.replace(regx, (match, start, end) => start + end.replace(/./g, maskChar));
            } else {
                regx = new RegExp('^(.*)(.{' + charCount + '})$', 'g');
                value = value.replace(regx, (match, start, end) => start.replace(/./g, maskChar) + end);
            }
        } else if (maskFlag && /email/i.test(maskFlag)) {
            value = value.replace(value.slice(0, value.lastIndexOf("@") - 2), "***");
        } else if (maskFlag && /phone/i.test(maskFlag)) {
            value = value.replace(value.slice(0, value.length - 2), "(***) *** - **");
        } else {
            console.log('mask exception', value);
        } 
        return value;
    }
}